var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFEEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6706 24.8735H23.3372C22.8082 24.8735 22.3789 25.3028 22.3789 25.8319V29.1652C22.3789 29.6942 22.8082 30.1235 23.3372 30.1235C23.8663 30.1235 24.2956 29.6942 24.2956 29.1652V26.7902H26.6706C27.1996 26.7902 27.6289 26.3609 27.6289 25.8319C27.6289 25.3028 27.1996 24.8735 26.6706 24.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 39.8735C46.1376 39.8735 45.7083 40.3028 45.7083 40.8319V43.2069H43.3333C42.8043 43.2069 42.375 43.6362 42.375 44.1652C42.375 44.6942 42.8043 45.1235 43.3333 45.1235H46.6667C47.1957 45.1235 47.625 44.6942 47.625 44.1652V40.8319C47.625 40.3028 47.1957 39.8735 46.6667 39.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 24.8735H43.3333C42.8043 24.8735 42.375 25.3028 42.375 25.8319C42.375 26.3609 42.8043 26.7902 43.3333 26.7902H45.7083V29.1652C45.7083 29.6942 46.1376 30.1235 46.6667 30.1235C47.1957 30.1235 47.625 29.6942 47.625 29.1652V25.8319C47.625 25.3028 47.1957 24.8735 46.6667 24.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6706 43.2069H24.2956V40.8319C24.2956 40.3028 23.8663 39.8735 23.3372 39.8735C22.8082 39.8735 22.3789 40.3028 22.3789 40.8319V44.1652C22.3789 44.6942 22.8082 45.1235 23.3372 45.1235H26.6706C27.1996 45.1235 27.6289 44.6942 27.6289 44.1652C27.6289 43.6362 27.1996 43.2069 26.6706 43.2069Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6576 28.21C26.1285 28.21 25.6992 28.6393 25.6992 29.1683V40.835C25.6992 41.364 26.1285 41.7933 26.6576 41.7933C27.1866 41.7933 27.6159 41.364 27.6159 40.835V29.1683C27.6159 28.6393 27.1866 28.21 26.6576 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0052 28.21C29.4762 28.21 29.0469 28.6393 29.0469 29.1683V37.5016C29.0469 38.0307 29.4762 38.46 30.0052 38.46C30.5342 38.46 30.9635 38.0307 30.9635 37.5016V29.1683C30.9635 28.6393 30.5342 28.21 30.0052 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3255 28.21C32.7965 28.21 32.3672 28.6393 32.3672 29.1683V37.5016C32.3672 38.0307 32.7965 38.46 33.3255 38.46C33.8546 38.46 34.2839 38.0307 34.2839 37.5016V29.1683C34.2839 28.6393 33.8546 28.21 33.3255 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 28.21C36.1363 28.21 35.707 28.6393 35.707 29.1683V40.835C35.707 41.364 36.1363 41.7933 36.6654 41.7933C37.1944 41.7933 37.6237 41.364 37.6237 40.835V29.1683C37.6237 28.6393 37.1944 28.21 36.6654 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9935 28.21C39.4645 28.21 39.0352 28.6393 39.0352 29.1683V37.5016C39.0352 38.0307 39.4645 38.46 39.9935 38.46C40.5225 38.46 40.9518 38.0307 40.9518 37.5016V29.1683C40.9518 28.6393 40.5225 28.21 39.9935 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 28.21C42.8043 28.21 42.375 28.6393 42.375 29.1683V40.835C42.375 41.364 42.8043 41.7933 43.3333 41.7933C43.8624 41.7933 44.2917 41.364 44.2917 40.835V29.1683C44.2917 28.6393 43.8624 28.21 43.3333 28.21Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.037 39.8735H30.0203C29.4896 39.8735 29.0703 40.3045 29.0703 40.8319C29.0703 41.3625 29.5096 41.7902 30.037 41.7902C30.566 41.7902 30.9953 41.3609 30.9953 40.8319C30.9953 40.3028 30.566 39.8735 30.037 39.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3651 39.8735H33.3484C32.8178 39.8735 32.3984 40.3045 32.3984 40.8319C32.3984 41.3625 32.8377 41.7902 33.3651 41.7902C33.8941 41.7902 34.3234 41.3609 34.3234 40.8319C34.3234 40.3028 33.8941 39.8735 33.3651 39.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0253 39.8735H40.0086C39.4779 39.8735 39.0586 40.3045 39.0586 40.8319C39.0586 41.3625 39.4978 41.7902 40.0253 41.7902C40.5543 41.7902 40.9836 41.3609 40.9836 40.8319C40.9836 40.3028 40.5543 39.8735 40.0253 39.8735Z",
    fill: "#FF6F61",
    stroke: "#FF6F61",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanNotificationIcon);
export default __webpack_public_path__ + "static/media/ScanNotificationIcon.414c4fc737556d78b7c719b65e560d35.svg";
export { ForwardRef as ReactComponent };